import React from 'react'
import type { MediaTileData } from './types'
import { MediaTile } from './MediaTile'
import { cn } from '@/lib/utils'
import { useAlbumInteractions } from '@/contexts/AlbumInteractionsContext'

interface Props {
  items: MediaTileData[]
  onTileClick: (item: MediaTileData) => void
  selectionMode: boolean
  selectedIds: Set<string>
  onToggleSelect: (id: string) => void
  showComments: boolean
  showLikes?: boolean
  gridClassName?: string
  gapClassName?: string
  tileClassName?: string
  className?: string
}

export const MediaGrid: React.FC<Props> = ({
  items,
  onTileClick,
  selectionMode,
  selectedIds,
  onToggleSelect,
  showComments,
  showLikes = false,
  gridClassName = 'grid-cols-3',
  gapClassName = 'gap-1 md:gap-2',
  tileClassName,
  className,
}) => {
  const { getCommentsCount, getVotesCount, hasCurrentUserVoted, hasCurrentUserCommented } = useAlbumInteractions();

  return (
    <div className={cn('grid', gapClassName, gridClassName, className)}>
      {items.map((item) => (
        <MediaTile
          key={item.id}
          item={item}
          onClick={onTileClick}
          selectionMode={selectionMode}
          selected={selectedIds.has(item.id)}
          onToggleSelect={onToggleSelect}
          showComments={showComments}
          showLikes={showLikes}
          tileClassName={tileClassName}
          commentsCount={getCommentsCount(item.id, item.comments_count ?? 0)}
          votesCount={getVotesCount(item.id, item.votes_count ?? 0)}
          isCommentedByCurrentUser={hasCurrentUserCommented(item.id, item.current_user_commented ?? false)}
          isVotedByCurrentUser={hasCurrentUserVoted(item.id, item.current_user_voted ?? false)}
        />
      ))}
    </div>
  )
}
